<app-half-background [images]="allianceImages" [shadow]="true" alt="Alliance search background">
    <ng-container image-contain>
        <section class="search content-without-footer">
            <div class="search-form-container container">
                <div class="row justify-content-center align-items-center">
                    <div class="heading col-sm-12 col-md-8 col-lg-9 text-center position-relative">
                        <div
                            class="dark-mode .search-logo-container mb-3"
                            [ngClass]="
                                currentTheme === 'dark' ? 'dark-mode .search-logo-container' : 'search-logo-container'
                            "
                        >
                            <app-facility-logo [height]="'136'" [width]="'186'"></app-facility-logo>
                        </div>
                        <div class="justify-content-center text-white">
                            <h1 class="mat-headline-3 mb-2 text-center">The Cargo People</h1>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </ng-container>
    <ng-container contain>
        <section class="search content-without-footer" appScrollTop>
            <div class="search-form-container container">
                <div class="d-flex align-items-center flex-column">
                    <div class="search-logo d-sm-block d-none">
                        <app-facility-logo [height]="'136'" [width]="'186'"></app-facility-logo>
                    </div>
                </div>
                <h4 class="mat-headline-4 mb-2 mt-4 text-center">Welcome to our customer portal</h4>
                <h6 class="mat-body-1 text-center mb-5">Pay your MAWB charges</h6>
                <app-search></app-search>
            </div>
        </section>
    </ng-container>
</app-half-background>
